import _DatabaseModel, { i18n } from "./_DatabaseModel";

const MAPPERS_TAB_DEFINITION = 102;
const MAPPERS_TAB_RUN = 103;

class Mapper extends _DatabaseModel {
  static model = "mapper";
  static editDialogComponent = "mappers-edit-dialog";

  static tableHeaders = [
    { textKey: "form.label.name", value: "name" },
    {
      textKey: "mapper.label.mapper_type",
      value: "mapper_type",
      translationPrefix: "mapper.mapper_types",
    },
  ];

  static show = {
    buttons: ["edit"],
    reloadingModels: ["mapper"],
  };

  static mapper_types = [
    "mail_receiver_mapper",
    "csv_mapper",
    "csv_generator",
    "json_mapper",
    "viskb_xml_generator",
  ];

  static cardFields(object) {
    return {
      title: object.name,
      subtitle: i18n.t(`mapper.mapper_types.${object.mapper_type}`),
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "mapper.label.mapper_type",
        value: i18n.t(`mapper.mapper_types.${object.mapper_type}`),
        type: "plain",
      },
      {
        labelKey: "form.label.updated_at",
        value: object.updated_at,
        type: "date_time",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "mapper.label.definition",
      permission: MAPPERS_TAB_DEFINITION,
      component: "JsonDefinitionTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "connector_run.connector_runs",
      permission: MAPPERS_TAB_RUN,
      component: "ConnectorRunsTab",
      disabled: () => false,
    },
  ];
}

export default Mapper;
